import React, { useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import 'styles/reset.css'
import 'styles/colors.css'
import Footer from './sections/Footer'
import ReactPixel from 'react-facebook-pixel'
import 'console-polyfill'
import 'fontsource-montserrat/400.css'
import 'fontsource-montserrat/500.css'
import 'fontsource-montserrat/600.css'
import 'fontsource-montserrat/700.css'
import 'styles/beatrice-font.css'

const Page = styled.div`
  position: relative;
  width: 100%;
  min-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`

const ContentWrapper = styled.main`
  width: 100%;
  flex: 1 1 auto;
`

let pixelInited = false

const Layout = ({ className, children, hideFooter }) => {
  useLayoutEffect(() => {
    if (!pixelInited && !!process.env.FACEBOOK_PIXEL_ID) {
      ReactPixel.init(process.env.FACEBOOK_PIXEL_ID, {}, {})
      pixelInited = true
      ReactPixel.track('ViewContent', {})
    }
  }, [])

  return (
    <Page className={className}>
      <ContentWrapper>{children}</ContentWrapper>
      {!hideFooter ? <Footer /> : null}
    </Page>
  )
}

Layout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  hideFooter: PropTypes.bool,
}

Layout.defaultProps = {
  hideFooter: false,
}

export default Layout
